import { rg4js } from 'helpers/raygun';

export function pushToDataLayer(data: { [key: string]: any }): void {
  try {
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push({ ...data, newPlatform: true });
    }
  } catch (e) {
    rg4js('send', {
      error: e,
      message: 'Error while trying to push data layer',
      metadata: {
        data,
      },
    });
  }
}
